import React from 'react'
import PropTypes from 'prop-types'
import {Col} from '@modifi/ui'
import {FormattedDate, FormattedNumber, useTranslation} from '@modifi/plugin-i18n'

import DownloadButton from './DownloadButton'
import {HeaderRow, ItemRow} from './styles'
import {invoiceListShape} from '../../shapes'

const InvoiceList = ({invoiceList, downloadInvoice}) => {
  const {t} = useTranslation('treseus')
  return (
    <>
      <HeaderRow>
        <Col xl={2} md={3}>
          {t('invoices-page.table-head.invoice.text')}
        </Col>
        <Col xl={2} md={3}>
          {t('invoices-page.table-head.date.text')}
        </Col>
        <Col xl={2} md={2}>
          {t('invoices-page.table-head.amount.text')}
        </Col>
        <Col xl={4} xlOffset={2} md={3}>
          {t('invoices-page.table-head.download.text')}
        </Col>
      </HeaderRow>

      {invoiceList.map(invoice => {
        const {externalInvoiceId, invoiceNumber, invoiceDate, invoiceAmount = {}} = invoice
        return (
          <ItemRow
            key={externalInvoiceId}
            my={12}
            data-ident="invoice-list-entry"
            data-invoice-number={invoiceNumber}
            data-invoice-external-id={externalInvoiceId}
          >
            <Col xl={2} md={3} sm={6}>
              <strong>{invoiceNumber}</strong>
            </Col>
            <Col xl={2} md={3} sm={6}>
              <FormattedDate format="D MMMM YYYY">{invoiceDate}</FormattedDate>
            </Col>
            <Col xl={2} md={2} sm={6}>
              {invoiceAmount.currency}{' '}
              <FormattedNumber>{Math.abs(invoiceAmount.amount)}</FormattedNumber>
            </Col>
            <Col xl={4} xlOffset={2} md={3} sm={6}>
              <DownloadButton
                type="pdf"
                data-target="download-pdf"
                invoice={invoice}
                expectedDuration={4000}
                onClick={downloadInvoice}
              />
              <DownloadButton
                type="csv"
                data-target="download-csv"
                invoice={invoice}
                expectedDuration={600}
                onClick={downloadInvoice}
              />
            </Col>
          </ItemRow>
        )
      })}
    </>
  )
}

InvoiceList.propTypes = {
  invoiceList: invoiceListShape.isRequired,
  downloadInvoice: PropTypes.func.isRequired,
}

export default InvoiceList
